'use strict';

function videoFunction(g) {
  function init() {
    // Quand la page est chargée, on lance l'autoplay à true

    var ready = false;
    document.onreadystatechange = function() {
      if (ready) {
        return;
      }

      if (document.readyState == 'complete') {
        ready = true;
        document.getElementById("bandeau__video").play();
      }
    };
  }

  init();
}
